import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { phaseChange, reroute } from '../../../../actions/Buy'
import {
  findomesticResetPin,
  findomesticUpdate,
  postContratti,
  postFindomesticFirmaPin,
} from '../../../../actions/buy/Findomestic'
import { postContrattiV2 } from '../../../../actions/buy/FindomesticFirmaV2'
import {
  getFinanziamentoAssicurato,
  getFinanziamentoNonAssicurato,
} from '../../../../utils/firmaUtils'
import OrderRecoveryBanner from '../../../dumb/OrderRecoveryBanner'
import BuyButton from '../../dumb/BuyButton'
import BuyMiniCart from '../../dumb/BuyMiniCart'
import BuyTextInput from '../../dumb/BuyTextInput'
import { preparaValoriLogistica } from '../../utils'

class FindomesticFirmaDigitale extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pinInputError: '',
      otpInputError: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 150 })

    if (this.props.customer && this.props.customer.token) {
      // richiede l'invio dell'otp
      if (!this.props.isV2) {
        this.props.postFindomesticFirmaPin()
      }
    }
  }

  handleSubmit() {
    if (this.props.isV2) {
      this.props
        .postContrattiV2()
        .then(() => this.props.reroute('/thank-you-firma'))
    } else if (
      this.props.findomestic.pin === this.props.findomestic.conferma_pin
    ) {
      this.props
        .postContratti()
        .then(() => this.props.reroute('/thank-you-firma'))
    }
  }

  render() {
    const { product } = this.props
    const valoriLogistica = preparaValoriLogistica(
      this.props.pricing.total,
      this.props.logistica
    )
    const h1 = 'Firma Digitale: sottoscrivi i documenti e concludi la richiesta'
    const t = this
    return (
      <div className="FindomesticInfocertFirma sellout-findomestic">
        <section className="relative process" id={'FindomesticFirmaDigitale'}>
          <div className="process__header">
            <h1 className="process__title">{h1}</h1>
          </div>
          <div className={'messages warning'}>
            <div className={'container'}>
              <OrderRecoveryBanner />
            </div>
          </div>
          <div className="user-informations">
            <div className="container_small">
              <div className="process__column process__column__left">
                <h1>Firma Digitale</h1>
                <p>
                  Inserisci{' '}
                  {!this.props.isV2
                    ? 'il PIN che hai scelto in precedenza e'
                    : ''}{' '}
                  l’OTP che riceverai a breve sul tuo numero di cellulare{' '}
                  <b>{this.props.findomestic.meta.mobile}</b>, come da te
                  precedentemente indicato. Prosegui per firmare digitalmente i
                  contratti.
                </p>
                <div className="space-50"></div>
                <ul className={'data-form x-small'}>
                  {!this.props.isV2 ? (
                    <li className={`${this.state.pinInputError} wide`}>
                      <BuyTextInput
                        classes="input-data form-input big"
                        defaultValue={''}
                        label={
                          'Inserisci PIN (8 cifre da te scelte in precedenza)'
                        }
                        onInput={event => {
                          t.props.findomesticUpdate({
                            pin: `${event.target.value}`,
                          })
                        }}
                        placeholder={'Scrivi il PIN'}
                        type={'number'}
                        update={event => {
                          if (
                            !/^\d+$/.test(event.target.value) ||
                            event.target.value !==
                              t.props.findomestic.conferma_pin
                          ) {
                            t.setState({ pinInputError: 'is-error' })
                          } else {
                            t.setState({ pinInputError: '' })
                          }
                        }}
                      />
                    </li>
                  ) : null}

                  <li className={`${this.state.otpInputError} wide`}>
                    <BuyTextInput
                      classes="input-data form-input big"
                      defaultValue={''}
                      label={'Inserisci OTP (codice ricevuto via sms)'}
                      onInput={event => {
                        t.props.findomesticUpdate({
                          otp: `${event.target.value}`,
                        })
                      }}
                      placeholder={'Scrivi il codice OTP'}
                      type={'number'}
                      update={event => {
                        if (!/^\d+$/.test(event.target.value)) {
                          t.setState({ otpInputError: 'is-error' })
                        } else {
                          t.setState({ otpInputError: '' })
                        }
                      }}
                    />
                  </li>

                  <div className="space-20"></div>
                  <p className="small brumbrum-link">
                    {!this.props.isV2
                      ? "Non ricordi il PIN oppure non ti arriva l'OTP?"
                      : "Non ti arriva l'OTP?"}
                    <a
                      onClick={() => {
                        if (!this.props.isV2) {
                          this.props.findomesticResetPin({})
                        }

                        this.props.reroute('/thank-you-findomestic')
                      }}
                    >
                      &nbsp;Clicca qui&nbsp;
                    </a>
                    per iniziare nuovamente il processo di firma digitale oppure
                    contatta il nostro servizio clienti allo 02.800.29
                  </p>
                </ul>

                <div className={'buttons_set center no-brd more-pd'}>
                  <BuyButton
                    classes={`btn btn-primary ${
                      this.props.fetching || !this.props.findomestic.otp?.length
                        ? ' btn-disabled'
                        : ''
                    }`}
                    label={'Prosegui'}
                    update={this.handleSubmit}
                  />
                </div>
              </div>
              <div className="process__column process__column__right">
                <BuyMiniCart
                  {...valoriLogistica}
                  acconti={this.props.ordine.acconti}
                  agevolazione_iva_104={
                    this.props.customer.agevolazione_iva_104
                  }
                  finanziamento={getFinanziamentoAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  finanziamentoNonAssicurato={getFinanziamentoNonAssicurato(
                    this.props.findomestic,
                    this.props.ordine,
                    this.props.financements
                  )}
                  idAuto={product.id_auto}
                  km={product.km}
                  ordine={this.props.ordine}
                  ownership={product.passaggio_proprieta_totale_generale}
                  paymentMethod={this.props.paymentMethod}
                  price={product.prezzo_sellout}
                  product={product}
                  sconto={this.props.ordine.sconto}
                  serviziAssicurativiSelezionati={
                    this.props.findomestic.servizi_assicurativi_selezionati
                  }
                  totalone={this.props.ordine.totale}
                  year={product.anno}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

FindomesticFirmaDigitale.defaultProps = {
  isV2: false,
}

FindomesticFirmaDigitale.propTypes = {
  product: PropTypes.object,
  ordine: PropTypes.object,
  pricing: PropTypes.object,
  logistica: PropTypes.object,
  fetching: PropTypes.bool,
  customer: PropTypes.object,
  findomestic: PropTypes.object,
  reroute: PropTypes.func,
  phaseChange: PropTypes.func,
  postContratti: PropTypes.func,
  postContrattiV2: PropTypes.func,
  postFindomesticFirmaPin: PropTypes.func,
  findomesticUpdate: PropTypes.func,
  findomesticResetPin: PropTypes.func,
  paymentMethod: PropTypes.string,
  financements: PropTypes.object,
  isV2: PropTypes.bool,
}

const mapStateToProps = state => ({
  pricing: state.pricing,
  product: state.product,
  ordine: state.ordine,
  findomestic: state.findomestic,
  logistica: state.logistica,
  customer: state.customer,
  fetching: state.ui.fetching,
  paymentMethod: state.payment.method,
  financements: state.financements,
})

const mapDispatchToProps = dispatch => ({
  reroute: payload => dispatch(reroute(payload)),
  phaseChange: payload => dispatch(phaseChange(payload)),
  findomesticUpdate: payload => dispatch(findomesticUpdate(payload)),
  findomesticResetPin: payload => dispatch(findomesticResetPin(payload)),
  postFindomesticFirmaPin: () => dispatch(postFindomesticFirmaPin),
  postContratti: () => dispatch(postContratti),
  postContrattiV2: () => dispatch(postContrattiV2),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FindomesticFirmaDigitale)
